import {produce} from 'immer';
import {useAtom} from 'jotai';
import {useState} from 'react';
import {Button} from '@/components/Button';
import {LoadingBar} from '@/components/LoadingBar';
import {
  SidePanelBase, SidePanelHead, SidePanelHeadTitleSection, SidePanelHeadTitleText,
  SidePanelScrollBody
} from '@/components/SidePanel/StyledComponents';
import {Typography} from '@/components/Typography';
import {useStarredBrands} from '@/map/api';
import {starredBrandsInfoAtom} from '@/map/atom';
import {Divider, FlexCenter, PaddingBox} from '@/styled-components';
import {palette} from '@/styles';
import {Edit} from './Edit';
import {Item} from './Item';

const MAX_COUNT = 30;

export const StarredBrands = () => {
  // 관심 브랜드 리스트
  const {data, isLoading} = useStarredBrands();

  const [menuInfo, setMenuInfo] = useAtom(starredBrandsInfoAtom);

  const [isEditMode, setEdit] = useState<boolean>(false);

  const onToggle = (brandId: string, _: boolean) => {
    setMenuInfo(
      produce((draft) => {
        const idx = draft.selected.findIndex((i: string) => i === brandId);

        if (idx >= 0) {
          draft.selected.splice(idx, 1);
        } else {
          draft.selected.push(brandId);
        }
      })
    );
  };

  if (isEditMode) {
    return (
      <Edit limitedBrandCount={MAX_COUNT} onBackClick={() => setEdit(false)} />
    );
  }

  return (
    <SidePanelBase>
      <SidePanelHead>
        <SidePanelHeadTitleSection>
          <SidePanelHeadTitleText>
            관심브랜드 ({isLoading ? '-' : data?.length ?? 0}/{MAX_COUNT})
          </SidePanelHeadTitleText>
        </SidePanelHeadTitleSection>
      </SidePanelHead>
      <SidePanelScrollBody>
        {!!data && data.length > 0 ? (
          data.map((brand) => (
            <Item
              key={brand.id}
              item={brand}
              active={menuInfo.selected.includes(brand.id)}
              onToggle={onToggle}
            />
          ))
        ) : (
          <FlexCenter>
            <PaddingBox spacing={16}>
              {isLoading ? (
                <LoadingBar color={palette.gray800} />
              ) : (
                <Typography variant="medium14">
                  추가된 관심 브랜드가 없습니다
                </Typography>
              )}
            </PaddingBox>
          </FlexCenter>
        )}
      </SidePanelScrollBody>
      <Divider />
      <PaddingBox spacing={[8, 16]}>
        <Button
          variant="outline"
          size="medium"
          fullWidth
          onClick={() => setEdit(true)}
        >
          편집
        </Button>
      </PaddingBox>
    </SidePanelBase>
  );
};
